import { createAPIHeaders, fetchUtility } from '.';
import { UserCustomData } from '../../types/user';

export const getCustomData = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/userCustomData`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const getUserOrgCustomData = async (apiKey: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/userOrgCustomData`, {
		headers: createAPIHeaders(apiKey, 'GET'),
		method: 'GET',
	});
};

export const updateCustomData = async (apiKey: string, newCustomData: UserCustomData): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/users/updateCustomData`, {
		headers: createAPIHeaders(apiKey, 'PATCH'),
		method: 'PATCH',
		body: JSON.stringify({
			touAgreed: newCustomData.touAgreed,
			theme: newCustomData.theme,
			keyphrasesHelpViewed: newCustomData.keyphrasesHelpViewed,
		}),
	});
};
